import {defineMessages} from "react-intl";

// Message structure for FAQ headers
export const FAQ_HEADERS =
  defineMessages({
    'Faq1': {
      id: 'Sell.FAQ.Header1',
      defaultMessage: 'How do I sell tickets on StubHub?'
    },
    'Faq2': {
      id: 'Sell.FAQ.Header2',
      defaultMessage: 'How can I sell concert tickets on StubHub?'
    },
    'Faq3': {
      id: 'Sell.FAQ.Header3',
      defaultMessage: 'How can I sell mobile tickets on StubHub?'
    },
    'Faq4': {
      id: 'Sell.FAQ.Header4',
      defaultMessage: 'What options do I have to deliver tickets I sell on StubHub?'
    }
  });
